import React from 'react'

const IndeterminateProgress = ({
  height = 10,
  color = '#1677ff', // default primary blue antd v5
  trackColor = '#edf0f5', // default gray track (sama chakra)
  borderRadius = '4px',
  ...props
}) => {
  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        height,
        backgroundColor: trackColor,
        borderRadius,
        overflow: 'hidden',
      }}
      {...props}
    >
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: '-40%',
          width: '40%',
          height: '100%',
          backgroundColor: color,
          borderRadius,
          animation: 'move-indeterminate 2.5s cubic-bezier(0.4, 0, 0.2, 1) infinite',
        }}
      />
    </div>
  )
}

export default IndeterminateProgress
